webpackJsonp([13],{

/***/ 713:
/*!****************************!*\
  !*** ./src/pages/Home.vue ***!
  \****************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 839);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3134213c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3134213c","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 870);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3134213c","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 869)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3134213c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 730:
/*!***************************************!*\
  !*** ./src/graphql/MediaFragment.gql ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Media"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Media"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":63}};
    doc.loc.source = {"body":"fragment Media on Media {\n  id kind name mime length alt data\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Media"] = oneQuery(doc, "Media");
        


/***/ }),

/***/ 731:
/*!************************************!*\
  !*** ./node_modules/lodash/map.js ***!
  \************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120),
    baseMap = __webpack_require__(/*! ./_baseMap */ 735),
    isArray = __webpack_require__(/*! ./isArray */ 11);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 735:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseMap.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ 122),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 773:
/*!******************************************************************!*\
  !*** ./src/pages/collections/graphql/CollectionListFragment.gql ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":229}};
    doc.loc.source = {"body":"#import \"../../../graphql/MediaFragment.gql\"\n\nfragment CollectionList on Collection {\n  id\n  name\n  published\n  baseline\n  featured\n  createdAt\n  updatedAt\n  categories {\n  \tid name\n  }\n  preview { ...Media }\n  products { id }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CollectionList"] = oneQuery(doc, "CollectionList");
        


/***/ }),

/***/ 779:
/*!***************************************************************!*\
  !*** ./src/pages/collections/graphql/CollectionListQuery.gql ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionFindAllInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"collectionsFindAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionList"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":244}};
    doc.loc.source = {"body":"#import \"./CollectionListFragment.gql\"\n\nquery($pagination: PaginationInput, $filter: CollectionFindAllInput) {\n  results: collectionsFindAll(pagination: $pagination, filter: $filter) {\n\ttotalCount\n\tedges {\n\t  node { ...CollectionList }\n\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./CollectionListFragment.gql */ 773).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 839:
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_app_mixin__ = __webpack_require__(/*! ../mixins/app-mixin */ 78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collections_graphql_CollectionListQuery_gql__ = __webpack_require__(/*! ./collections/graphql/CollectionListQuery.gql */ 779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collections_graphql_CollectionListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__collections_graphql_CollectionListQuery_gql__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_app_mixin__["a" /* AppMixin */]],
  components: {},
  data: function data() {
    return {
      collections: [],
      helpVisible: false,
      helpSection: 0
    };
  },

  apollo: {
    collections: {
      query: __WEBPACK_IMPORTED_MODULE_2__collections_graphql_CollectionListQuery_gql___default.a,
      fetchPolicy: "network-only",
      variables: function variables() {
        return {
          pagination: {
            limit: 999
          }
        };
      },

      update: function update(data) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data.results.edges, "node");
      }
    }
  }
});

/***/ }),

/***/ 869:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3134213c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Home.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 870:
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3134213c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('row',[_c('column',{attrs:{"lg":_vm.helpVisible? 8: 4}},[_c('div',{staticClass:"well well-lg"},[(!_vm.helpVisible)?[_c('h1',[_vm._v("Bienvenue sur votre interface d'administration Netexial !")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n          Vous débutez dans la gestion des produits du catalogue ?\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.helpVisible = true}}},[_vm._v("Suivez le guide !")])]:[_c('h1',[_vm._v("Petit guide pratique à l'usage des administrateurs")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',{staticClass:"list-inline list-inline-dotted text-center"},[_c('li',[_c('a',{class:{'text-bold': !_vm.helpSection},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.helpSection = 0}}},[_vm._v("Structure générale")])]),_vm._v(" "),_c('li',[_c('a',{class:{'text-bold': _vm.helpSection === 1},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.helpSection = 1}}},[_vm._v("Couleurs")])]),_vm._v(" "),_c('li',[_c('a',{class:{'text-bold': _vm.helpSection === 2},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.helpSection = 2}}},[_vm._v("Produits et options")])]),_vm._v(" "),_c('li',[_c('a',{class:{'text-bold': _vm.helpSection === 3},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.helpSection = 3}}},[_vm._v("Groupes et combinaisons")])]),_vm._v(" "),_c('li',[_c('a',{class:{'text-bold': _vm.helpSection === 4},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.helpSection = 4}}},[_vm._v("Déclinaisons")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(!_vm.helpSection),expression:"!helpSection"}]},[_c('h5',[_vm._v("1 ) Structure générale")]),_vm._v(" "),_c('p',[_vm._v("\n            Tous les produits sont regroupés au sein de "),_c('strong',[_vm._v("collections")]),_vm._v(". Chaque collection peut apparaître dans un "),_c('strong',[_vm._v("métier")]),_vm._v(".\n            Pour pouvoir commencer à renseigner des produits, il faut donc avant tout qu'ils soient dans une arborescence de collections et de métiers.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Dans un premier temps, il vous faudra vous rendre sur la page de "),_c('router-link',{attrs:{"to":{name: 'categories'},"target":"_blank"}},[_vm._v("Gestion des métiers")]),_vm._v(",\n            muni(e) de la liste ordonnée des métiers et des fichiers image des icônes de chaque métier.\n          ")],1),_vm._v(" "),_c('p',[_vm._v("\n            Une fois que les métiers sont renseignés, il est possible de continuer avec la "),_c('router-link',{attrs:{"to":{name: 'collections'},"target":"_blank"}},[_vm._v("Gestion des collections")]),_vm._v(".\n            Dans cette partie, vous aurez besoin des informations de chaque collection, notamment :\n          ")],1),_vm._v(" "),_c('ul',[_c('li',[_vm._v("le nom et le slogan,")]),_vm._v(" "),_c('li',[_vm._v("le métier associé,")]),_vm._v(" "),_c('li',[_vm._v("les images qui seront utilisées comme image d'accueil, de menu, de page "),_c('em',[_vm._v("En savoir +")]),_vm._v(" et pour la fiche collection,")]),_vm._v(" "),_c('li',[_vm._v("les informations liées aux risques et aux normes de sécurité.")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.helpSection = 1}}},[_vm._v("Suivant »")])]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.helpSection === 1),expression:"helpSection === 1"}]},[_c('h5',[_vm._v("2 ) Couleurs")]),_vm._v(" "),_c('p',[_vm._v("\n            Cette partie est certes rébarbative, mais elle est indispensable afin de pouvoir renseigner les produits.\n            Il vous faudra vous rendre sur la "),_c('router-link',{attrs:{"to":{name: 'colors'},"target":"_blank"}},[_vm._v("Gestion des couleurs")]),_vm._v(" et renseigner\n            l'ensemble des couleurs disponibles sur les produits que vous souhaitez ajouter.\n          ")],1),_vm._v(" "),_c('p',[_vm._v("\n            Pour cela, munissez-vous de la liste des couleurs existantes, simples ou bicolores, et si possible "),_c('strong',[_vm._v("organisée selon les collections ou produits")]),_vm._v(" dans lesquelles elles sont utilisées.\n            Pour chaque couleur, renseignez le nom et un nom de groupe qui vous permettra de facilement retrouver une couleur et affecter un groupe de couleurs.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Par exemple, si vous avez une série de couleurs utilisées pour quasiment tous les produits d'une collection, utilisez comme nom de groupe cette collection.\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Attention : si 2 collections ont aujourd'hui la même couleur (même nom et codes couleurs), il peut être important de créer une couleur distincte pour chaque collection.")]),_vm._v("\n            Cela permettra d'accélerer le processus de création des produits et de faciliter le travail au cas où une des 2 versions serait amenée à être modifiée à long terme.\n          ")]),_vm._v(" "),_c('p',[_vm._v("Quand tout a été renseigné, il est désormais plus rapide de gérer tous les produits.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.helpSection = 2}}},[_vm._v("Suivant »")])]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.helpSection === 2),expression:"helpSection === 2"}]},[_c('h5',[_vm._v("3 ) Produits et options")]),_vm._v(" "),_c('p',[_vm._v("\n            L'interface propose 4 types de produits : les vêtements, les linges, les tapis et les accessoires. Pour chacun le principe est le même : il faut paramétrer les informations\n            générales du produit, notamment son affichage et les propriétés (attributs) possibles, puis compléter les "),_c('strong',[_vm._v("déclinaisons")]),_vm._v(", c'est-à-dire les références différentes en fonction de la couleur,\n            la taille, etc.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            La décomposition d'un produit et de ses déclinaisons est fortement liée à la manière dont on souhaite afficher le produit dans l'interface. Il existe 2 grandes stratégies :\n          ")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("organiser un produit comme un ensemble d'options ;")]),_vm._v(" "),_c('li',[_vm._v("créer une multitude de produits comme des déclinaisons, avec un minimum d'options pour chacun.")])]),_vm._v(" "),_c('p',[_vm._v("Prenons comme exemple une veste avec les options suivantes :")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("la couleur générale, qui est limitée à quelques couleurs de la collection ;")]),_vm._v(" "),_c('li',[_vm._v("la couleur du liseré, parmi 2 ou 3 options possibles ;")]),_vm._v(" "),_c('li',[_vm._v("la matière ;")]),_vm._v(" "),_c('li',[_vm._v("le sexe ;")]),_vm._v(" "),_c('li',[_vm._v("la présence ou non de poches.")])]),_vm._v(" "),_c('p',[_vm._v("\n            La première possibilité est de "),_c('strong',[_vm._v("créer un seul produit")]),_vm._v(" « Veste » qui contiendra les 5 options.\n            En "),_c('router-link',{attrs:{"to":{name: 'product/create'},"target":"_blank"}},[_vm._v("créant le produit")]),_vm._v(" et en sélectionnant le type de produit\n            « Vêtement », une liste de propriétés est pré-remplie. Il suffit de supprimer les propriétés non nécessaires et de rajouter\n            une propriété « Poches » pour avoir :\n          ")],1),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Sexe : choix parmi « Homme » et « Femme » ;")]),_vm._v(" "),_c('li',[_vm._v("Matière : choix parmi « CR » et « PC » ;")]),_vm._v(" "),_c('li',[_vm._v("Couleur : options choisies parmi celles possibles dans les déclinaisons ;")]),_vm._v(" "),_c('li',[_vm._v("Liseré : options choisies parmi celles possibles dans les déclinaisons ;")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Poches : choix parmi « Avec » et « Sans ».")])])]),_vm._v(" "),_c('p',[_vm._v("\n            Avec ce système, l'utilisateur choisit parmi les vestes avec poches ou sans poches en tant qu'option, au même titre que la matière ou la couleur.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Une deuxième possibilité est de "),_c('strong',[_vm._v("créer un produit par variante")]),_vm._v(", par exemple : « Veste CR avec poche »,\n            « Veste CR sans poche », « Veste PC »… Dans ce cas, on réduit le nombre de propriétés pour chaque\n            produit, ce qui peut donner par exemple :\n          ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Sexe : choix parmi « Homme » et « Femme » ;")]),_vm._v(" "),_c('li',[_vm._v("Couleur : options choisies parmi celles possibles dans les déclinaisons ;")]),_vm._v(" "),_c('li',[_vm._v("Liseré : options choisies parmi celles possibles dans les déclinaisons ;")])]),_vm._v(" "),_c('p',[_vm._v("\n            En décomposant de cette manière, l'utilisateur choisit entre différents produits plutôt que différentes options. Il n'y a pas de choix meilleur qu'un\n            autre, il faut néanmoins privilégier la compréhension et la cohérence globale pour l'utilisateur.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Enfin, en plus des propriétés on définit pour chaque produit un ensemble d'images qui seront utilisées dans les déclinaisons. Cela permet de sélectionner\n            une image existante pour plusieurs déclinaisons plutôt que de télécharger plusieurs fois la même image.\n          ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.helpSection = 3}}},[_vm._v("Suivant »")])]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.helpSection === 3),expression:"helpSection === 3"}]},[_c('h5',[_vm._v("4 ) Groupes et combinaisons")]),_vm._v(" "),_c('p',[_vm._v("\n            En décomposant les produits en plusieurs, ou bien en voulant associer des produits entre eux, on fait appel au concept de groupes / combinaisons.\n            Cela permet de "),_c('strong',[_vm._v("regrouper en une entité nommée des produits")]),_vm._v(".\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Le premier cas d'utilisation est celui des combinaisons : par exemple pouvoir configurer comme une seule entité une partie haute et une partie basse.\n            Pour cela, dans "),_c('router-link',{attrs:{"to":{name: 'product/create'},"target":"_blank"}},[_vm._v("l'édition ou la création d'un produit")]),_vm._v(" il suffit de cocher la case\n            « Ce produit fait partie d'une combinaison / d'un groupe ». Cela fait apparaître une liste déroulante ainsi qu'un bouton de gestion.\n            Il est ensuite possible d'ajouter une combinaison (ex : « Haut + Bas ») et de renseigner les parties qui la composent (ex : « Haut »,\n            « Bas »). En associant ensuite le produit à une des parties de la combinaison, le configurateur présentera la combinaison comme un\n            point d'entrée à part au même niveau que les produits qui ne font pas partie d'une combinaison, et les produits qui la composent seront regroupées selon leurs parties.\n          ")],1),_vm._v(" "),_c('p',[_vm._v("\n            Mais puisque la combinaison est une entrée du même niveau que les produits, et puisqu'aussi lorsqu'il n'y a qu'une seule partie dans une combinaison son intitulé n'est pas affiché,\n            il est possible d'utiliser ce système pour "),_c('strong',[_vm._v("grouper les produits")]),_vm._v(".\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Ce deuxième cas d'utilisation fait écho à la décomposition des produits en fonction de leurs options (exemple 2 vu précédemment).\n            En supposant que 3 produits « Veste CR avec poche », « Veste CR sans poche », « Veste PC » ont\n            été créés, le problème principal qui se pose est qu'ils seront affichés en haut de page au même niveau. Il est possible d'utiliser les groupes pour\n            améliorer l'affichage pour l'utilisateur.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Pour cela, toujours dans "),_c('router-link',{attrs:{"to":{name: 'product/create'},"target":"_blank"}},[_vm._v("l'édition ou la création d'un produit")]),_vm._v(" on va créer un groupe spécial\n            qu'on nommera « Veste », avec une seule partie « Toutes » (comme ce nom ne s'affichera pas dans l'interface, il n'a pas d'importance).\n            Ensuite, il faudra affecter nos 3 produits à ce groupe. Dans l'interface, cela permettra d'avoir les 3 produits regroupés au sein d'un produit virtuel (le groupe) nommé\n            proprement « Veste ». Puis, en choisissant ce produit, l'utilisateur a ensuite le choix entre les 3 versions de cette veste.\n          ")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.helpSection = 4}}},[_vm._v("Suivant »")])]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.helpSection === 4),expression:"helpSection === 4"}]},[_c('h5',[_vm._v("5 ) Déclinaisons")]),_vm._v(" "),_c('p',[_vm._v("\n            Une fois que les produits sont correctement paramétrés et rangés dans leurs groupes ou combinaisons, il reste l'essentiel  renseigner les déclinaisons.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Pour accéder à l'interface de gestion des déclinaisons d'un produit, il est possible de cliquer sur le nombre de déclinaisons du produit dans la liste, de cliquer sur\n            l'action « Gérer les déclinaisons » du produit dans la liste, ou bien encore sur le bouton « Gérer les déclinaisons »\n            en haut de page de l'édition d'un produit.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Il est possible d'ajouter chaque déclinaison une par une, mais l'option la plus rapide est de "),_c('strong',[_vm._v("générer des déclinaisons")]),_vm._v(" par lot.\n            Pour cela, un formulaire s'ouvre et permet de choisir les valeurs qui seront déclinées. Par exemple, en choisissant « Homme », « Femme »\n            pour la propriété « Sexe » et « Bleu », « Rouge », « Vert » pour la propriété « Couleur »,\n            6 déclinaisons (2 × 3) seront générées dans la liste. Il est ensuite plus facile de renseigner pour chacune leur référence, description et de sélectionner\n            l'image qui correspond.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Le générateur de déclinaisons permet également de nettoyer des déclinaisons qui ne seraient plus valides (ex : couleur plus disponible). En cochant les cases qui s'affichent dans le cas\n            ou des déclinaisons obsolètes sont détectées, ces dernières sont enlevées et ne polluent plus l'interface.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Une fois les déclinaisons créées, paramétrées, publiées au sein d'un produit dans une collection publiés, l'utilisateur y a accès et peut le configurer et l'ajouter à son panier.\n            "),_c('strong',[_vm._v("Le tour est joué !")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.helpVisible = false}}},[_vm._v("J'ai tout compris !")])])]],2)]),_vm._v(" "),_c('column',{attrs:{"lg":_vm.helpVisible? 4: 8}},[_c('panel',{attrs:{"light":""}},[(_vm.$apollo.loading)?_c('div',[_c('h4',[_vm._v("Chargement…")])]):_c('row',_vm._l((_vm.collections),function(collection){return _c('column',{key:collection.id,staticClass:"text-center",attrs:{"lg":_vm.helpVisible? 12: 4}},[_c('div',{staticClass:"Collection"},[_c('h4',[_c('router-link',{attrs:{"to":{name: 'collection/edit', params: {id: collection.id}}}},[_c('i',{staticClass:"icon-pencil icon-left"})]),_vm._v("\n              "+_vm._s(collection.name)+"\n            ")],1),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":{name: 'products', query: {collection: collection.id}}}},[_vm._v("\n                "+_vm._s(collection.products.length)+" produit(s)\n              ")])],1)])])}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// 13.46dbad2b.chunk.js